// src/components/SearchingRequestPage.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import VariousCompanyCards from './VariousCompanyCards';
import './IndexConent/indexContent.css'; // Если стили для загрузки используются
import './pages/pageLawAndVendorsList.css'; // Импортируем новый стиль для кнопки

function SearchingRequestPage(props) {
    const { resultToken } = useParams();

    const [legalCompanies, setLegalCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [suggestion, setSuggestion] = useState('');
    const [visibleCompanies, setVisibleCompanies] = useState(5);
    const companiesPerPage = 5;

    const handleGlobalPopupTrigger = (companyObject) => {
        let companyId;

        if (typeof companyObject === 'object' && companyObject !== null && companyObject.id) {
            companyId = companyObject.id;
        } else if (typeof companyObject === 'string' || typeof companyObject === 'number') {
            companyId = companyObject;
        } else {
            return;
        }

        const companyData = legalCompanies.find(c => String(c.id) === String(companyId));

        if (companyId && props.onShowPopup) {
            if (companyData) {
                props.onShowPopup(companyId, 'company');
            } else {
                props.onShowPopup(companyId, 'company');
            }
        }
    };

    useEffect(() => {
        if (resultToken) {
            setLoading(true);
            setError(null);
            setSuggestion('');
            api.get(`newo-leads/details/${resultToken}/`)
                .then(response => {
                    const companies = response.data.legal_companies || [];
                    setLegalCompanies(companies);
                    if (companies.length === 0 && (!response.data.suggestion || response.data.suggestion.trim() === '')) {
                        setSuggestion("No legal companies found for your request.");
                    } else if (response.data.suggestion) {
                        setSuggestion(response.data.suggestion);
                    } else {
                        setSuggestion('');
                    }
                    setLoading(false);
                })
                .catch(err => {
                    const errorMsg = err.response?.data?.error || "Failed to load data";
                    const errorStatus = err.response?.status;
                    setError({ message: errorMsg, status: errorStatus });
                    setSuggestion(errorMsg);
                    setLegalCompanies([]);
                    setLoading(false);
                });
        } else {
            setLegalCompanies([]);
            setLoading(false);
            setError(null);
            setSuggestion('Result token not found.');
        }
    }, [resultToken]);

    const showMoreCompanies = () => {
        setVisibleCompanies(prevVisibleCompanies => prevVisibleCompanies + companiesPerPage);
    };

    if (loading) {
        return (
            <main className='emptyContent'>
                <div className='content'>
                    <span className='title empty-animate'>{'Loading companies...'}</span>
                </div>
            </main>
        );
    }

    if (error) {
        return (
            <div className="page-container" style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                <h1 className="page-title--vendors-style">Error</h1>
                <p>{error.message}</p>
                {error.status && <p>Status: {error.status}</p>}
            </div>
        );
    }

    const currentCompanies = legalCompanies.slice(0, visibleCompanies);

    return (
        <div className="page-container" style={{ padding: '10px' }}>
            <h3 className="page-title--vendors-style" style={{ textAlign: 'left', marginBottom: '10px', marginLeft: '30px' }}>
                Law Companies in your request
            </h3>

            {suggestion && suggestion.trim() !== '' && <p style={{ textAlign: 'center', fontStyle: 'italic' }}>{suggestion}</p>}

            {legalCompanies.length > 0 ? (
                <>
                    <div className="accordeon__el">
                        <div className="accordeon__content">
                            <VariousCompanyCards
                                lawCompanies={currentCompanies}
                                onShowPopup={handleGlobalPopupTrigger}
                            />
                        </div>
                    </div>
                    {visibleCompanies < legalCompanies.length && (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button onClick={showMoreCompanies} className="load-more-btn">
                                Show More
                            </button>
                        </div>
                    )}
                </>
            ) : (
                !loading && !suggestion && <p style={{ textAlign: 'center' }}>No legal companies found for your request.</p>
            )}
        </div>
    );
}

export default SearchingRequestPage;